<template>
  <div class="A1">
    <!-- 头部 -->
    <Header></Header>
    <!-- 内容 -->
    <div class="container" :style="{'background':`url('${dataObj.bigPicUrl}') no-repeat center top`}">
      <div class="wrap">
        <div class="navigation">
          <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">{{$t('otherPage.p1')}}</el-breadcrumb-item>
              <el-breadcrumb-item @click.native="toUrl(firstNav.url)">{{firstNav.title}}</el-breadcrumb-item>
              <el-breadcrumb-item>{{$t('otherPage.p9')}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="back" @click="toBack" :style="{'width' : $store.getters.lang=='en'?'114px':''}">
            <img src="@/assets/images/ExhibitionA1Detail01@2x.png" alt=""> {{$t('otherPage.p20')}}
          </div>
        </div>
        <div class="main">
          <div class="main-t">
            <img :src="dataObj.picUrl_Nei" alt="">
            <div class="message">
              <div class="title">
                <span>{{$t('otherPage.p21')}}</span><span>{{dataObj.title}}</span>
              </div>
              <div class="date">
                <span>{{$t('otherPage.p22')}}</span><span>{{dataObj.date}}</span>
              </div>
              <div class="address">
                <span>{{$t('otherPage.p23')}}</span><span>{{dataObj.address}}</span>
              </div>
            </div>
            <div class="summary" v-html="dataObj.detail1"></div>
          </div>
          <div class="main-b" v-if="dataObj.detail2">
            <div class="title">{{$t('otherPage.p24')}}</div>
            <div class="content" v-html="dataObj.detail2"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import {getShowRoom} from "@/api"
  // import {getExhibitionA1Detail} from "@/api"
  import Header from "@/common/Header";
  import Footer from "@/common/Footer";
  import {mixin} from '@/mixin/index.js';

  export default {
    name: "Detail",
    mixins:[mixin],
    components: {
      Header,
      Footer,
    },
    data() {
      return {
        // 一级Nav
        firstNav: {},
        // 详情数据
        dataObj:{},
        // 大图
        bigPicUrl:''
      }
    },
    watch:{
      '$store.getters.lang' : function(val) {
        // 更新静态数据(后退)
        this.$router.go(-1);
      }
    },
    created() {
      // 设置背景颜色
      document.body.style.backgroundColor = "#f2f2f2"
      // 获取详情对应的一级导航
      if(this.$store.getters.lang =='zh'){
        this.$store.getters.menu.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }else{
        this.$store.getters.menuEn.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.$set(this,"firstNav",val)
          }
        })
      }
      // 获取数据
      this.toGetData()
      this.toGetBanner()
    },
    methods: {
      // 获取数据
      toGetBanner(){
        this.$store.getters.banner.forEach((val) => {
          if (this.$route.path.indexOf(val.name) != -1) {
            this.bigPicUrl = val.url
          }
        })
      },
      async toGetData() {
        let {data: {data}} = await getShowRoom({
          id : this.$route.params.id,
        })

        if(!data){
          this.$router.push('/404');
        }
        // console.log(data)

        let detail2 = ''
        let showFacethum = data.showFacethum ? data.showFacethum.split(',') : []
        showFacethum.forEach(val=>{
          detail2 += '<img width="100%" src="' + this.$store.getters.urlApi + val + '" alt="">'
        })

        this.dataObj = {
          id : data.id,
          title : this.$store.getters.lang=='en'?data.showTitleEn:data.showTitle,
          date : this.$store.getters.lang=='en'?'Long-term':'长期',
          address : this.$store.getters.lang=='en'?data.showAddressEn:data.showAddress,
          classify : this.$store.getters.lang=='en'?data.showTypeEn:data.showType,
          bigPicUrl : this.bigPicUrl,
          picUrl_Nei : this.$store.getters.urlApi + data.showFace,
          detail1 : this.$store.getters.lang == 'en' ? this.updateImageUrl(data.showContentEn) : this.updateImageUrl(data.showContent),
          detail2
        }
      },
      // 返回
      toBack(){
        this.$router.go(-1);
      },
      // 跳转二级导航
      toUrl(path) {
        if (this.$router.currentRoute.path !== path) {
          this.$router.push(path);
        }
      }
    },
  }
</script>


<style scoped lang="less">

  /deep/ .el-breadcrumb__inner {
    color: #fff !important;
  }
  .el-breadcrumb {
    font-size: 20px;
  }

  .el-breadcrumb__item {
    cursor: pointer;
  }

  .container {
    background-size: cover;
    overflow: hidden;

    .wrap {
      width: 1380px;
      margin: 190px auto 140px;

      .navigation {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .back {
          width: 92px;
          height: 38px;
          line-height: 38px;
          background: #FFFFFF;
          text-align: center;
          font-family: PingFangSC;
          font-weight: 500;
          font-size: 18px;
          color: #999999;
          cursor: pointer;
          img {
            margin-right: 6px;
            position: relative;
            top: -2px;
          }
        }

      }

      .main-t {
        margin-top: 30px;
        padding: 60px 59px 54px;
        background: #fff;
        img{
          width: 100%;
        }
        .message {
          display: flex;

          .title {
            display: flex;
            flex-direction: column;
            width: 420px;
            padding: 30px 0;

            span:nth-of-type(1) {
              font-family: Source Han Sans CN;
              font-size: 24px;
              color: #666666;
            }

            span:nth-of-type(2) {
              font-family: PingFangSC;
              font-weight: 500;
              font-size: 32px;
              color: #333333;
              margin-top: 20px;
            }
          }

          .date {
            width: 326px;
            display: flex;
            flex-direction: column;
            border-left: 1px solid #d7d7d7;
            border-right: 1px solid #d7d7d7;
            padding: 30px 0 30px 118px;

            span:nth-of-type(1) {
              font-family: Source Han Sans CN;
              font-size: 24px;
              color: #666666;
            }

            span:nth-of-type(2) {
              font-family: PingFangSC;
              font-weight: 500;
              font-size: 32px;
              color: #333333;
              margin-top: 14px;
            }
          }

          .address {
            width: 513px;
            display: flex;
            flex-direction: column;
            padding: 30px 0 30px 146px;

            span:nth-of-type(1) {
              font-family: Source Han Sans CN;
              font-size: 24px;
              color: #666666;
            }

            span:nth-of-type(2) {
              font-family: PingFangSC;
              font-weight: 500;
              font-size: 32px;
              color: #333333;
              margin-top: 14px;
            }
          }
        }

        .summary {
          font-family: PingFangSC;
          font-weight: 400;
          font-size: 24px;
          color: #333333;
          line-height: 36px;
          padding: 24px 0 0;
          border-top: 1px solid #d7d7d7;
          text-align: justify;
          word-break: break-all;
          /deep/ p,/deep/ span{
            font-size: 22px !important;
            color: #333333 !important;
            line-height: 1.75 !important;
          }
          /deep/ img{
            max-width: 100% !important;
          }
        }
      }

      .main-b {
        margin-top: 30px;
        padding: 60px 59px 54px;
        background: #fff;

        .title {
          font-family: PingFangSC;
          font-weight: 500;
          font-size: 34px;
          color: #333333;
          margin-bottom: 40px;
        }

        .content {
          font-size: 24px;
          color: #333333;
          line-height: 36px;

          img {
            max-width: 100%;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Exhibition/A1/Detail.vue